<template>
  <div>
    <div class="box" v-if="value">
      <div class="h5 main" style="padding:20px 0 48px 0">주문제작 상담 상세</div>
      <div class="columns">
        <div class="column is-5" style="padding-right: 30px">
          <div class="detail-title">서비스 정보</div>
          <div style="margin-bottom:80px">
            <div class="flex">
              <div class="col-4">
                <div class="subtitle7 sub3">작성일자</div>
                <div class="body2 sub2">{{ datesFormat(value.created_time, 'date_time_2') }}</div>
              </div>
              <div class="col-1"></div>
              <div class="col-7">
                <div class="subtitle7 sub3">진행 상태</div>
                <div class="flex">
                  <div :class="`status status-${value.status}`">{{ contentStatus(value) }}</div>
                </div>
                <button v-if="value.status === 0"
                        class="button is-primary-light"
                        style="width:150px;margin-top:8px" @click="clickStatusDone">등록 완료로 상태 변경</button>
              </div>
            </div>
            <div class="subtitle7 sub3">파일 카테고리</div>
            <div class="body2 sub2">{{ value.category }}</div>
            <div class="subtitle7 sub3 word-wrap">제목</div>
            <div class="body2 sub2">{{ value.title }}</div>
            <div class="subtitle7 sub3">내용</div>
            <div class="body2 sub2 word-wrap">{{ value.content }}</div>
            <div class="subtitle7 sub3">서비스 url</div>
            <a :href="value.url" target="_blank">
              <div class="body2 sub2">{{ value.url }}</div>
            </a>
            <div class="subtitle7 sub3">판매 파일</div>
            <div v-for="(file,idx) in value.files" :key="`file-${idx}`">
              <a :href="file" target="_blank">
                <div class="box-file">
                  <img :src="svgSrc('draw_api')">
                  <div class="body4 main" style="text-decoration: none">{{ file.split('/').pop() }}</div>
                </div>
              </a>
            </div>
          </div>

          <div class="detail-title">신청자 정보</div>
          <div>
            <div class="subtitle7 sub3">성함(혹은 회사명)</div>
            <div class="body2 sub2">{{ value.name }}</div>
            <div class="subtitle7 sub3">연락처</div>
            <div class="body2 sub2">{{ value.phone }}</div>
            <div class="subtitle7 sub3">이메일</div>
            <div class="body2 sub2">{{ value.email }}</div>
          </div>
        </div>
        <div v-if="value.talk && value.talk > 0" class="column is-7" style="padding-left:30px">
          <launch-talk :isMemo="!value.user || value.user.guest" :talkId="value.talk" :talks.sync="talks"></launch-talk>
        </div>
      </div>
    </div>
    <div class="flex-center" style="margin-top:80px">
      <button class="button is-gray" style="width:242px;height:52px !important;font-size:15px !important;" @click="$router.back()">목록으로</button>
    </div>
  </div>
</template>

<script>
  import LaunchTalk from "../../../module/common/LaunchTalk";

  export default {
    layout: 'Main',
    name: 'SourceInquiryDetail',
    components: {LaunchTalk},
    data() {
      return {
        value: {},
        talks: [],
      }
    },
    created() {
      this.getData();
    },
    methods: {
      getData() {
        this.$axios.get(this.getUrl(`inquiry/source/${this.$route.query.id}`))
          .then(res => {
            if (res.status === 200) {
              this.value = res.data;
            }
          })
      },
      clickStatusDone() {
        if(confirm('파일 등록완료 상태로 변경하시겠습니까?')) {
          this.$axios.patch(this.getUrl(`inquiry/source/${this.$route.query.id}`), {status: 1}).then(res => {
            if(res.status === 200) {
              this.value.status = 1;
            }
          });
        }
      },
      contentStatus(menu) {
        return {
          0: '문의내용 확인중',
          1: '파일 등록완료'
        }[menu.status];
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .detail-title
    color $main
    font-size 24px
    line-height 34px
    font-weight 500
    padding-bottom 16px
    border-bottom 1px solid $sub5
    margin-bottom 32px

  .grid
    grid-template-columns 0.3fr 1fr
    grid-row-gap 16px

  .clip
    transform rotate(45deg)
    color $sub3
    font-size 18px
    vertical-align sub
    margin-right 8px

  .subtitle7
    margin 24px 0 4px 0
  .subtitle7:first-child
    margin-top 0

  a
    text-decoration underline

  .word-wrap
    white-space pre-line
    word-break break-word

  .status
    padding 4px 8px
    border-radius 4px
    font-size 13px
    font-weight 500
  .status-0
    background-color $gray3
    color $sub2
  .status-1
    background-color $subcolor50
    color $subcolor2

  .box-file
    margin-top 4px
    display flex
    align-items center
    border 1px solid $gray
    padding 10px 12px
    border-radius 8px
    gap 8px
    img
      width 18px
      height 18px
</style>
